/**
 * Types of participants that can be added to a Specialist Group.
 */
export enum SpecialistGroupParticipantType {
  User = 'user',
  MedicalUnit = 'medicalUnit',
}

/**
 * Types of organizations that can be affiliated with a Specialist Group.
 */
export enum SpecialistGroupAffiliationType {
  MedicalUnit = 'medicalUnit',
  JurisdictionalGroup = 'jurisdictionalGroup',
}

/**
 * Types of relationships an organization can have with a Specialist Group.
 */
export enum AffiliationsType {
  allowed = 'allowed',
  preferred = 'preferred',
}
